<template>
  <div id="woodText" style="padding-bottom: 15px;">
    <h2 style="text-align: left; position: relative; top: 5px;">{{getText.title}}</h2>
    <div v-if="product == 'table'" style="position: relative;">
      <div id="chosenPlanks">
        <p style="position: relative; top: 5px; text-align: left; padding-bottom: 10px; margin: 0;">
        {{getTextTable.abovePlanks}}
        <br />
        <v-radio-group v-model="tableSolidBoard">
          <v-radio
            :label="getTextTable.planksSingle"
            color="var(--accentColor)"
            value="single"
          ></v-radio>
          <v-radio
            :label="getTextTable.planksSolid + ' (+' + getTableSolidPrice + '€)'"
            color="var(--accentColor)"
            value="solid"
          ></v-radio>
        </v-radio-group>
        <br />
        {{getText.numberOfAvailablePlanks1}} {{getPlanksTable.availablePlanks.length}} {{getText.numberOfAvailablePlanks2}}<br />
        {{getText.choiceOfPlanks}}
        {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[0].index]}};
        {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[1].index]}}
        <span v-if="getNumberOfPlanksTable > 2">; {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[2].index]}}</span>
        <span v-if="getNumberOfPlanksTable > 3">; {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[3].index]}}</span>
        </p>
      </div>
      <ConfiguratorTableWood :mobile="mobile" style="position: relative; left: -15px;"/>
    </div>
    <div v-if="product == 'tableOffice'" style="position: relative;">
      <div id="chosenPlanks">
        <p style="position: relative; top: 5px; text-align: left; padding-bottom: 10px; margin: 0;">
        {{getTextTableOffice.abovePlanks}}
        <br /> <br />
        {{getText.numberOfAvailablePlanks1}} {{getPlanksTableOffice.availablePlanks.length}} {{getText.numberOfAvailablePlanksBoard}}<br />
        {{getText.choiceOfPlanks}}<br />
        </p>
      </div>
      <div class="selector">
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksTableOffice.used[0].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankTableOffice(0, 'down')" >
            <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
          </v-btn>
        </div>
        <div>
          <h2 style="position: relative; top: 10px;">{{getPlanksTableOffice.availablePlanksTitle[getPlanksTableOffice.used[0].index]}}</h2>
        </div>
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksTableOffice.used[0].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankTableOffice(0, 'up')" >
            <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="product == 'shelf'" style="position: relative;max-height: 60vh;overflow:auto;">
      <div id="chosenPlanks">
        <p style="position: relative; top: 5px; text-align: left; padding-bottom: 10px; margin: 0;">
        {{getTextShelf.abovePlanks}}
        <br /> <br />
        {{getText.numberOfAvailablePlanks1}} {{getPlanksShelf.availablePlanks.length}} {{getText.numberOfAvailablePlanks2}}<br />
        {{getText.choiceOfPlanks}}<br />
        <!-- 1: {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[0].index]}} <br />
        2: {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[1].index]}} <br />
        <span v-if="getPlanksTable.numberOfPlanks == 3 || getPlanksTable.numberOfPlanks == 4">3: {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[2].index]}}</span> <br />
        <span v-if="getPlanksTable.numberOfPlanks == 4">4: {{getPlanksTable.availablePlanksTitle[getPlanksTable.used[3].index]}}</span> -->
        <ul style="list-style-type: none; margin: 0; padding: 0;">
          <li v-for="(plank, index)  in getPlanksShelf.active.planks" :key="index" class="shelfListElement">
            <div>
              <v-btn v-bind:class="{hidden : !getPlanksShelf.active.planks[index].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changeShelfPlank(index, 'down')" >
                <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
              </v-btn>
            </div>
            <div>
              Ebene {{getPlanksShelf.active.planks.length - index}}: {{plank.name}}
            </div>
            <div>
              <v-btn v-bind:class="{hidden : !getPlanksShelf.active.planks[index].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changeShelfPlank(index, 'up')" >
                <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
              </v-btn>
            </div>
          </li>
        </ul>
        </p>
      </div>
      <!-- <ConfiguratorShelfWood :mobile="mobile" style="position: relative; left: -15px;"/> -->
    </div>
    <div v-if="product == 'bench'" style="position: relative;">
      <div id="chosenPlanks">
        <p style="position: relative; top: 5px; text-align: left;">
        {{getTextBench.abovePlanks}}
        <br /> <br />
        {{getText.numberOfAvailablePlanks1}} {{getPlanksBench.availablePlanks.length}} {{getText.numberOfAvailablePlanks2}}
        {{getText.choiceOfPlanks}}<br />
        </p>
      </div>
      <div class="selector">
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksBench.used[0].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankBench(0, 'down')" >
            <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
          </v-btn>
        </div>
        <div>
          <h2 style="position: relative; top: 10px;">{{getPlanksBench.availablePlanksTitle[getPlanksBench.used[0].index]}}</h2>
        </div>
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksBench.used[0].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankBench(0, 'up')" >
            <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="product == 'stool'" style="position: relative;">
      <div id="chosenPlanks">
        <p style="position: relative; top: 5px; text-align: left;">
        {{getTextStool.abovePlanks}}
        <br /> <br />
        {{getText.numberOfAvailablePlanks1}} {{getPlanksStool.availablePlanks.length}} {{getText.numberOfAvailablePlanks2}}
        {{getText.choiceOfPlanks}}<br />
        </p>
      </div>
      <div class="selector">
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksStool.used[0].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankStool(0, 'down')" >
            <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
          </v-btn>
        </div>
        <div>
          <h2 style="position: relative; top: 10px;">{{getPlanksStool.availablePlanksTitle[getPlanksStool.used[0].index]}}</h2>
        </div>
        <div>
          <v-btn v-bind:class="{hidden : !getPlanksStool.used[0].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlankStool(0, 'up')" >
            <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
          </v-btn>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ConfiguratorTableWood from '@/components/ConfiguratorTableWood.vue'
// import ConfiguratorShelfWood from '@/components/ConfiguratorShelfWood.vue'

export default {
  name: 'WoodText',
  props: ['product', 'mobile'],
  data() {
    return{
      tableSolidBoard: "single",
    }
   },
   components: {
     ConfiguratorTableWood,
     // ConfiguratorShelfWood
   },
   computed: {
     getText(){ return this.$store.getters.getText.configurator.wood },
     getNumberOfPlanksTable(){return this.$store.getters.getTableConfig.planks.numberOfPlanks},
     getPlanksTable() {return this.$store.getters.getTableConfig.planks;},
     getPlanksTableOffice() {return this.$store.getters.getTableOfficeConfig.planks;},
     getPlanksShelf() {return this.$store.getters.getShelfConfig.planks;},
     getPlanksBench() {return this.$store.getters.getBenchConfig.planks;},
     getPlanksStool() {return this.$store.getters.getStoolConfig.planks;},
     getTextTable(){return this.$store.getters.getText.tableConfigurator.configurator.chooseWood;},
     getTextTableOffice(){return this.$store.getters.getText.tableOfficeConfigurator.configurator.chooseWood;},
     getTextShelf(){return this.$store.getters.getText.shelfConfigurator.configurator.chooseWood;},
     getTextBench(){return this.$store.getters.getText.benchConfigurator.configurator.chooseWood;},
     getTextStool(){return this.$store.getters.getText.stoolConfigurator.configurator.chooseWood;},
     getTableSolidPrice(){return this.$store.getters.getTableConfig.tableTopTypes.solid},
   },
   methods: {
     changeShelfPlank(index, direction){
       var payload= {direction: direction, position: index}
       this.$store.dispatch("changeShelfPlank", payload);
     },
     changePlankTableOffice(index, direction){
       var payload= {direction: direction, position: index}
       this.$store.dispatch("changeTableOfficeConfig", {change: 'changePlank', value: payload});
     },
     changePlankBench(index, direction){
       var payload= {direction: direction, position: index}
       this.$store.dispatch("changeBenchConfig", {change: 'changePlank', value: payload});
     },
     changePlankStool(index, direction){
       var payload= {direction: direction, position: index}
       this.$store.dispatch("changeStoolConfig", {change: 'changePlank', value: payload});
     },
     changePlankTable(index, direction){
       var payload= {direction: direction, position: index}
       this.$store.dispatch("changeTableConfig", {change: 'changePlank', value: payload});
     }
   },
   watch: {
     tableSolidBoard: function(){
        this.$store.dispatch("changeTableConfig", {change: 'tableTop', value: this.tableSolidBoard});
     },
   }
}
</script>

<style scoped>
.hidden{
  visibility: hidden;
}
  #configuratorDesktopSize {
    height: 100%;
    width: 100%;
  }
  #buttons{
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  #sizeSlider{
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
  }
  .selector{
    margin-bottom: 25px;
    display: grid;
    poasition: relative;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .tableSelector{
    height: 50px;
  }
  .desktopLeft{
    position: relative;
    right: -10px;
    top: 10px;
    background-color: var(--accentColor);
    border-radius: 50%;
  }
  .desktopRight{
    position: relative;
    left: -10px;
    top: 10px;
    background-color: var(--accentColor);
    border-radius: 50%;
  }
  .rightArrow{
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  .leftArrow{
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .shelfListElement{
  position: relative;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  height: 55px;
  }
</style>
